export const allStates = [
    { title: "All Provinces", code: 0 },
    { title: "Province 1",    code: 1 },
    { title: "Province 2",    code: 2 },
    { title: "Bagmati",       code: 3 },
    { title: "Gandaki",       code: 4 },
    { title: "Lumbini",       code: 5 },
    { title: "Karnali",       code: 6 },
    { title: "Sudurpaschim",  code: 7 },
];
 